export default {
  name: "Lagunitas",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/logo-color.webp`,
  products: [
    {
      id: "ipa",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/en/product-foward_ipa.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/fr/product-foward_ipa.webp`,
      },
      name: {
        en: "IPA",
        fr: "IPA",
      },
      description: {
        en: "A well-rounded, Highly drinkable India Pale Ale. A bit of Caramel Malt barley provides the richness that mellows out the twang of the hops.",
        fr: "Une India Pale Ale bien équilibrée et facile à boire. Une légère touche de malt d'orge caramélisé offre la richesse qui adoucit les notes du houblon.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/en/information_render_can_330ml500ml_lagunitas.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/fr/information_render_can_330ml500ml_lagunitas.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/en/information_nft_allrenders_lagunitas.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/fr/information_nft_allrenders_lagunitas_fr.webp`,
          },
          name: {
            en: "Can 330ml",
            fr: "Canette  330ml",
          },
        },
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/en/information_render_can_330ml500ml_lagunitas.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/fr/information_render_can_330ml500ml_lagunitas.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/en/information_nft_allrenders_lagunitas.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/lagunitas/fr/information_nft_allrenders_lagunitas_fr.webp`,
          },
          name: {
            en: "Can 500ml",
            fr: "Canette 500ml",
          },
        },
      ],
    },
  ],
};
